module.exports = __webpack_public_path__ + "img/qilin-stage7-sulking.2ab383c1.png";